module.exports = __webpack_public_path__ + "img/kirisame magic shop.a0db9a71.png";